export const ENTERPRISE_VALID_EMAIL_DOMAINS = ['ninjatech.ai', 'amazon.com'];
export const ENTERPRISE_INVALID_DOMAIN_MESSAGE =
  'Please use your @amazon.com email address to sign up or log in.';
